import { createReducer, on } from '@ngrx/store';
import * as NavigationActions from './navigation.actions';
import { BaseState } from '../../base.state';

export const initialState: BaseState = {
    error: null,
    loading: true
};

export const navigationReducer = createReducer(
    initialState,
    on(NavigationActions.navigationStart, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(NavigationActions.navigationEnd, (state) => ({
        ...state,
        loading: false,
        error: null,
    })),
    on(NavigationActions.showSpinner, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(NavigationActions.hideSpinner, (state) => ({
        ...state,
        loading: false,
        error: null,
    }))
);
